export default __webpack_public_path__ + "static/media/origami_group.e3be5d18.mp4";